// components/layout/ResultsLayout.js
import React from 'react';
import {Stack, Box, useMediaQuery} from '@mui/material';
import {ResultsHeader} from './ResultsHeader';
import {SwipeableContainer} from './SwipeableContainer';
import {ResultsFooter} from './ResultsFooter';
import HealthCategoryNav from '../../../../components/NavigationBar/HealthCategoryNavigationBar';

export const ResultsLayout = ({
  organization,
  features,
  slides,
  activeIndex,
  onSlideChange,
  onCategorySelect,
  categories,
  headerData,
  footerProps,
  swiperRef,
  children,
}) => {
  const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up('lg'));

  // Get current slide information
  const currentSlide = slides[activeIndex];
  const currentSlideKey = currentSlide?.key;

  // Debug logging
  console.log('ResultsLayout currentSlide:', currentSlide);
  console.log('ResultsLayout footerProps:', footerProps);

  if (isLargeScreen) {
    return (
      <div className="large-parent-div-1">
        <div className="large-parent-div">
          <Stack className="large-sliders-container">
            <ResultsHeader
              organization={organization}
              headerData={headerData}
              features={features}
              isLargeScreen={true}
              {...headerData.navigationProps}
            />

            <SwipeableContainer
              slides={slides}
              activeIndex={activeIndex}
              onSlideChange={onSlideChange}
              onCategorySelect={onCategorySelect}
              categories={categories}
              isLargeScreen={true}
              config={organization.config}
              swiperRef={swiperRef}
              cardRef={footerProps?.cardRef}
            />

            {organization.config?.resultPageSlider?.isResultPageSliderVisible &&
              categories &&
              categories.length > 0 && (
                <Box sx={{position: 'relative', bottom: '80px'}}>
                  <HealthCategoryNav
                    categories={categories}
                    activeIndex={activeIndex}
                    onSelectCategory={onCategorySelect}
                    isLargeScreen={true}
                    clientBaseNavCss={organization.config.resultPageSlider}
                  />
                </Box>
              )}

            <Stack
              direction="column"
              alignItems="center"
              sx={{
                width: '100%',
                position: 'relative',
                bottom: organization.config?.resultPageSlider?.isResultPageSliderVisible ? '80px' : '44px',
              }}
            >
              {footerProps && (
                <ResultsFooter
                  organization={organization}
                  features={features}
                  config={organization.config}
                  currentSlideKey={currentSlideKey}
                  headerData={headerData}
                  sortedMetricsByHealthOrder={currentSlide?.props?.sortedMetricsByHealthOrder}
                  {...footerProps}
                />
              )}
              {children}
            </Stack>
          </Stack>
        </div>
      </div>
    );
  }

  // Mobile layout
  return (
    <div className="parent-div">
      <Stack>
        <SwipeableContainer
          slides={slides}
          activeIndex={activeIndex}
          onSlideChange={onSlideChange}
          onCategorySelect={onCategorySelect}
          categories={categories}
          isLargeScreen={false}
          config={organization.config}
          swiperRef={swiperRef}
          cardRef={footerProps?.cardRef}
        />
      </Stack>
    </div>
  );
};
